<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate">Configuraciones de la plataforma</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'Configuraciones' }, { label: 'Plataforma' }]" />
    </div>
  </section>

  <section wrapper>
    <p-accordion [value]="['0', '1']" [multiple]="true">
      <p-accordion-panel value="0" *showForPermissions="['robots_sidea']" class="mb-2">
        <p-accordion-header>
          <div class="d-flex flex-row justify-content-between align-items-center gap-2 w-100 pe-3">
            <h6 class="m-0">Robots para la plataforma SIDEA.</h6>
            <div class="d-flex flex-row justify-content-between align-items-center gap-2">
              <p-button label="Nuevo robot" icon="pi pi-plus" size="small" (click)="openDrawer($event, 'robotSidea')" />
            </div>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <p-drawer header="Nuevo Robot SIDEA" [(visible)]="robotSideaDrawerOpen" [dismissible]="false" [closable]="false" position="right" [style]="{ 'max-width': '400px', width: '90%' }">
            <div class="d-flex flex-column gap-4">
              <div class="d-flex flex-column gap-2">
                <label for="">Nombre del Robot</label>
                <input [(ngModel)]="robotSideaForm.nameCurp" pInputText id="" aria-describedby="robotname-help" placeholder="CURP" />
                <input [(ngModel)]="robotSideaForm.nameBot" pInputText id="" aria-describedby="robotname-help" placeholder="Nombre" />
                <small id="robotname-help">Ingrese el nombre del robot.</small>
              </div>
              <div class="d-flex flex-column gap-2">
                <label for="interval">Intervalo de solicitudes</label>
                <p-inputnumber [(ngModel)]="robotSideaForm.interval" min="0" placeholder="10" />
                <small id="interval-help">Ingrese el intervalo de solicitudes del robot.</small>
              </div>
              <div class="d-flex flex-column gap-2">
                <label for="limit">Límite de solicitudes</label>
                <p-inputnumber [(ngModel)]="robotSideaForm.limit" min="0" placeholder="100" />
                <small id="limit-help">Ingrese el límite de solicitudes del robot.</small>
              </div>
            </div>

            <ng-template #footer>
              <div class="d-flex align-items-center justify-content-between gap-2">
                <p-button (click)="this.closeDrawer('robotSidea')" label="Cancelar" severity="secondary" size="small" class="w-50" styleClass="w-100 py-3" [disabled]="robotSideaFormSaving" />
                <p-button
                  (click)="saveRobotSidea()"
                  label="Guardar"
                  icon="pi pi-save"
                  [loading]="robotSideaFormSaving"
                  severity="success"
                  size="small"
                  class="w-50"
                  styleClass="w-100 py-3"
                  [disabled]="!robotSideaForm.nameCurp || !robotSideaForm.nameBot || !robotSideaForm.interval || !robotSideaForm.limit"
                />
              </div>
            </ng-template>
          </p-drawer>

          <div class="card page-section">
            @for (item of robotSideaList; track $index) {
              <div class="card-body p-0">
                <robot-sidea [data]="item" (deleted)="onRobotDeleted($event)"></robot-sidea>
              </div>
            }
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel value="1" *showForPermissions="['provider_create']" class="mb-2">
        <p-accordion-header>
          <div class="d-flex flex-row justify-content-between align-items-center gap-2 w-100 pe-3">
            <h6 class="m-0">Proveedores</h6>
            <div class="d-flex flex-row justify-content-between align-items-center gap-2">
              <p-button label="Nuevo proveedor" icon="pi pi-plus" size="small" (click)="openDrawer($event, 'provider')" />
            </div>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <p-drawer header="Nuevo proveedor" [(visible)]="providerDrawerOpen" [dismissible]="false" [closable]="false" position="right" [style]="{ 'max-width': '400px', width: '90%' }">
            <div class="d-flex flex-column gap-4">
              <div class="d-flex flex-column gap-2">
                <label for="provider">Proveedor</label>
                <input [(ngModel)]="providerForm.provider" pInputText id="provider" aria-describedby="provider-help" />
                <small id="provider-help">Ingrese el nombre del proveedor.</small>
              </div>
              <div class="d-flex flex-column gap-2">
                <label for="module">Módulo</label>
                <p-select [(ngModel)]="providerForm.module" [options]="providerModuleList" optionLabel="label" optionValue="value" [filter]="true" placeholder="Selecciona un módulo" class="w-100">
                  <ng-template let-item #item>
                    <div class="d-block text-wrap" style="max-width: 300px">{{ item.label }}</div>
                  </ng-template>
                </p-select>
                <small id="module-help">Selecciona un módulo.</small>
              </div>
              <div class="d-flex flex-column gap-2">
                <label for="cost">Costo por acción</label>
                <p-inputnumber [(ngModel)]="providerForm.cost" inputId="currency-mx" mode="currency" currency="MXN" locale="es-MX" prefix="MXN " min="0" />
                <small id="cost-help">Ingrese el costo por acción del módulo.</small>
              </div>
            </div>

            <ng-template #footer>
              <div class="d-flex align-items-center justify-content-between gap-2">
                <p-button (click)="this.closeDrawer('provider')" label="Cancelar" severity="secondary" size="small" class="w-50" styleClass="w-100 py-3" [disabled]="providerFormSaving" />
                <p-button
                  (click)="saveProvider()"
                  label="Guardar"
                  icon="pi pi-save"
                  [loading]="providerFormSaving"
                  severity="success"
                  size="small"
                  class="w-50"
                  styleClass="w-100 py-3"
                  [disabled]="!providerForm.provider || !providerForm.module || !providerForm.cost"
                />
              </div>
            </ng-template>
          </p-drawer>

          <div class="card page-section">
            <div class="card-body p-2 pt-0">
              <p-table [value]="providersList" dataKey="id" editMode="row" showGridlines [tableStyle]="{ 'min-width': '60rem' }">
                <ng-template #header>
                  <tr>
                    <th>ID</th>
                    <th>Proveedor</th>
                    <th>Módulo</th>
                    <th>Costo por acción</th>
                    <th>Estado</th>
                    <th>Fecha de registro</th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template #body let-item let-editing="editing" let-ri="rowIndex">
                  <tr [pEditableRow]="item">
                    <td>{{ item.id }}</td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <input [(ngModel)]="editValue.name" type="text" pInputText class="w-100" />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{ item.provider }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>{{ this.getModule(item.module) }}</td>
                    <td>
                      <p-cellEditor>
                        <ng-template pTemplate="input">
                          <p-inputNumber [(ngModel)]="editValue.price" inputId="minmaxfraction" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="5" class="w-100" />
                        </ng-template>
                        <ng-template pTemplate="output">
                          {{ item.cost | currency: "MXN" }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td>
                      <p-tag [value]="getStatus(item.status)" [severity]="getSeverity(item.status) || 'secondary'" />
                    </td>
                    <td>{{ item.dateCreated | date: "longDate" }}</td>
                    <td class="text-center">
                      <div class="flex align-items-center justify-content-center gap-2">
                        @if (!editing && !editValue.onEdit) {
                          <button pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onRowEditInit(item)" class="p-button-rounded p-button-text"></button>
                        }
                        <!---->
                        @if (editing && editValue.onEdit) {
                          <button pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" (click)="onRowEditSave(item)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
                          <buttonon
                            pButton
                            pRipple
                            type="button"
                            pCancelEditableRow
                            icon="pi pi-times"
                            (click)="onRowEditCancel(item, ri)"
                            class="p-button-rounded p-button-text p-button-danger"
                          ></buttonon>
                        }
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </section>
</backbone>
